import { memo } from 'react';
import { Handle, Position, NodeProps, useReactFlow } from 'reactflow';
import { ShoppingBag, Trash2, Info } from 'lucide-react';

export const PostSaleNode = memo(({ id }: NodeProps) => {
  const { deleteElements } = useReactFlow();

  const handleDelete = () => {
    deleteElements({ nodes: [{ id }] });
  };

  return (
    <div className="bg-neutral-900 border-2 border-green-500/40 rounded-lg p-4 min-w-[320px] shadow-lg">
      <Handle type="target" position={Position.Top} className="w-3 h-3 !bg-green-500" />

      <div className="flex items-center gap-2 mb-3">
        <ShoppingBag className="w-5 h-5 text-green-400" />
        <span className="font-bold text-white">Pós-Venda</span>
        <div className="ml-auto flex items-center gap-1">
          <button
            onClick={handleDelete}
            className="text-red-400 hover:text-red-300 transition-colors p-1"
            title="Deletar nó"
          >
            <Trash2 className="w-4 h-4" />
          </button>
        </div>
      </div>

      <div className="space-y-3">
        <div className="flex items-start gap-2 p-3 bg-blue-500/10 border border-blue-500/30 rounded-lg">
          <Info className="w-4 h-4 text-blue-400 flex-shrink-0 mt-0.5" />
          <div className="text-xs text-brand-ivory/90 leading-relaxed">
            Este nó é acionado automaticamente após uma venda confirmada.
            Use as variáveis abaixo nas mensagens seguintes.
          </div>
        </div>

        <div className="space-y-2">
          <p className="text-xs font-semibold text-brand-gold">Variáveis disponíveis:</p>
          <div className="grid grid-cols-1 gap-1.5">
            <div className="text-xs text-brand-ivory/70 bg-neutral-800 px-2 py-1.5 rounded font-mono">
              {'{{nome_cliente}}'} - Nome do cliente
            </div>
            <div className="text-xs text-brand-ivory/70 bg-neutral-800 px-2 py-1.5 rounded font-mono">
              {'{{numero_pedido}}'} - Número do pedido
            </div>
            <div className="text-xs text-brand-ivory/70 bg-neutral-800 px-2 py-1.5 rounded font-mono">
              {'{{data_venda}}'} - Data da venda
            </div>
            <div className="text-xs text-brand-ivory/70 bg-neutral-800 px-2 py-1.5 rounded font-mono">
              {'{{metodo_pagamento}}'} - Forma de pagamento
            </div>
            <div className="text-xs text-brand-ivory/70 bg-neutral-800 px-2 py-1.5 rounded font-mono">
              {'{{numero_parcelas}}'} - Nº de parcelas
            </div>
            <div className="text-xs text-brand-ivory/70 bg-neutral-800 px-2 py-1.5 rounded font-mono">
              {'{{valor_parcela}}'} - Valor da parcela
            </div>
            <div className="text-xs text-brand-ivory/70 bg-neutral-800 px-2 py-1.5 rounded font-mono">
              {'{{total_pedido}}'} - Total do pedido
            </div>
            <div className="text-xs text-brand-ivory/70 bg-neutral-800 px-2 py-1.5 rounded font-mono">
              {'{{endereco_entrega}}'} - Endereço completo
            </div>
            <div className="text-xs text-brand-ivory/70 bg-neutral-800 px-2 py-1.5 rounded font-mono">
              {'{{produtos}}'} - Lista de produtos
            </div>
            <div className="text-xs text-brand-ivory/70 bg-neutral-800 px-2 py-1.5 rounded font-mono">
              {'{{quantidade_produtos}}'} - Qtd. de produtos
            </div>
          </div>
        </div>
      </div>

      <Handle type="source" position={Position.Bottom} className="w-3 h-3 !bg-green-500" />
    </div>
  );
});

PostSaleNode.displayName = 'PostSaleNode';
